$(document).ready(function(){
  (function addTopbarLinksToMobileMenu() {
    try {
      var $allLinks = $('.site-announcement .topbar-nav-wrapper .topbar-menu-item').clone().addClass('navmenu-item');
      if ($allLinks.length > 0) {
        $allLinks.find('a.topbar-menu-link').addClass('navmenu-link');
        $allLinks.appendTo($('.mobile-nav-panel .mobile-nav-content ul'));
      }
    } catch (error) {
      console.log("Error occured in addTopbarLinksToMobileMenu() at custom.js\n", error);
    }
  })();
});

window.addEventListener("load", function() {
  if (document.querySelector(".product-moldings-wrapper .moldings-thumbs-wrapper.splide") && !document.querySelector(".product-moldings-wrapper .moldings-thumbs-wrapper.splide.splide-slide")) {
    var t = new Splide(".product-moldings-wrapper .moldings-thumbs-wrapper.splide",{
            type: "slide",
            fixedWidth: 110,
            isNavigation: !0,
            perMove: 1,
            autoHeight: !0,
            gap: "15px",
            pagination: !1,
            arrows: !0,
            breakpoints: {
                1023: {
                    fixedWidth: 90,
                    autoWidth: !1,
                    perPage: 6
                },
                767: {
                    gap: "10px",
                    fixedWidth: !1,
                    autoWidth: !1,
                    perPage: 4,
                    arrows: !1
                }
            }
        })
          , e = new Splide(".product-moldings-wrapper .moldings-carousel-wrapper.splide",{
            type: "slide",
            perPage: 1,
            perMove: 1,
            autoHeight: !0,
            gap: 0,
            pagination: !1,
            arrows: !1,
            isNavigation: !1,
            breakpoints: {
                767: {
                    pagination: !0
                }
            }
        });
        e.sync(t),
        e.mount(),
        t.mount()
  }
});